import { createRESTConn } from "../../../Common";
import { ConnectionNames } from "../../../Contracts";
import { RCRequestFormatter } from "../RCRequestFormatter";
export function createRealityCheckConnection() {
    return createRESTConn({
        name: ConnectionNames.realityCheck,
        handlers: {
            requestFormatter: RCRequestFormatter
        }
    });
}
//# sourceMappingURL=CreateRealityCheckConnection.js.map